import { createContextWithHooks } from '@/shared/utils/react';

export type MinimizedWindow = {
  id: string;
  title: string;
  icon?: React.ReactNode;
  onClose: () => void;
  onRestore: () => void;
};

// `ordinal`: stable 1-based number among same-titled windows, assigned at
// first minimize so pill labels never renumber while their draft lives.
export type DockedWindow = MinimizedWindow & { ordinal: number };

// One registry with explicit lifecycle transitions. A draft's record exists
// from openWindow until closeWindow; minimizeWindow/restoreWindow only flip
// its status. Slot and ordinal live on the record — a restored draft
// re-minimizes into the same pill — and closing frees them, so the next
// draft starts numbering from what is actually alive.
export type MinimizedWindowsContextValue = {
  closeWindow: (id: string) => void;
  minimizeWindow: (window: MinimizedWindow) => void;
  openWindow: (id: string) => void;
  restoreWindow: (id: string) => void;
};

// Consumed optionally: when no provider is mounted (e.g. a KpcModal used
// outside a case), the minimize affordance is hidden and the modal behaves
// exactly as before, so nothing changes for the rest of the app.
const minimizedWindowsContext =
  createContextWithHooks<MinimizedWindowsContextValue>('MinimizedWindows');

export default minimizedWindowsContext;
